export enum MercerCareerStream {
  Executive = 'Executive',
  Management = 'Management',
  Professional = 'Professional',
  ParaProfessional = 'Para-Professional'
}
